import React from 'react';
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Tutorial } from "@/assets";

interface TextFieldProps {
  value: string;
  onChange: (value: string) => void;
  hasErrors?: boolean;
  required?: boolean;
  label: string;
  description?: string;
  videoUrl?: string;
}

export const TextField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  hasErrors,
  required = false,
  label,
  description,
  videoUrl
}) => {
  const isInvalid = hasErrors && required && !value;

  return (
    <>
      <h1 className="text-background font-bold text-sm sm:text-2xl mb-2.5 sm:mb-4">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </h1>
      {description && (
        <h2 className="text-grey-light text-sm sm:text-base mb-6 sm:mb-8">{description}</h2>
      )}
      
      <p className="text-grey-light text-xs sm:text-sm mb-4 italic">
        Digite o texto desejado
      </p>
      
      <div className="flex flex-col justify-center text-xs sm:text-sm gap-4 w-full">
        <Textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="min-h-[200px] placeholder:text-background/60 border border-background rounded-md focus-visible:ring-0 resize-none"
          placeholder="Digite aqui..."
          rows={8}
        />
      </div>

      {videoUrl && (
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="ghost" className="flex gap-2 items-center bg-background/10 rounded-md w-fit px-4 py-2 mt-4">
              <Tutorial fill="var(--background)" />
              <span>Ver vídeo explicativo</span>
            </Button>
          </DialogTrigger>
          <DialogContent className="aspect-video min-w-2/3 bg-black/90 rounded-2xl border border-gray-800 text-grey-light">
            <div style={{ left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '56.25%' }}>
              <iframe
                src={videoUrl}
                style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }}
                allowFullScreen
                scrolling="no"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
              >
              </iframe>
            </div>
          </DialogContent>
        </Dialog>
      )}
      
      {isInvalid && (
        <div className="text-red-500 text-sm mt-2">Este campo é obrigatório</div>
      )}
    </>
  );
}; 